import { createContext, useEffect, useState } from "react";
import { getItemFromStore } from "../helpers/utils";

const UserContext = createContext({
    userData      : { user: {} },
    handleUserData: () => {}
});

const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState({ user: {} });

    const handleUserData = (data) => {
        setUserData(prev => ({ ...prev, ...data }));
    };

    useEffect(() => {
        const user = getItemFromStore("userInfo");
        handleUserData(user);
    }, []);

    return (
        <UserContext.Provider value={{ userData, handleUserData }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };
